import * as index from './BuyAbility/index.js';

/**
 * This file serves as the central registry for all frontier blocks.
 * Each block should register itself by importing and calling its own init function.
 */

// Initialize frontier blocks registry
var frontierBlocks = {};
// Add new blocks here:
// import * as NewBlock from './NewBlock';

// List of all blocks
var blocks = [index
// Add new blocks here:
// NewBlock,
];

// Register all blocks
blocks.forEach(function (block) {
  var _block$default, _block$default$regist;
  block === null || block === void 0 || (_block$default = block.default) === null || _block$default === void 0 || (_block$default$regist = _block$default.register) === null || _block$default$regist === void 0 || _block$default$regist.call(_block$default, frontierBlocks);
});

/**
 * Re-initialize MFE's dynamic imports to refresh the remote module versions
 */
function initializeMFEs() {
  // Initialize all blocks
  blocks.forEach(function (block) {
    var _block$default2, _block$default2$initB;
    block === null || block === void 0 || (_block$default2 = block.default) === null || _block$default2 === void 0 || (_block$default2$initB = _block$default2.initBlock) === null || _block$default2$initB === void 0 || _block$default2$initB.call(_block$default2);
  });
}

// Initialize MFEs
initializeMFEs();

export { frontierBlocks, initializeMFEs };
